// Filename - components/SidebarData.js

import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import { IoMdPeople ,IoIosPaper,IoMdClipboard} from 'react-icons/io'; // Import IoMdPeople icon
import { MdManageAccounts } from 'react-icons/md'; // Import MdAdminPanelSettings icon
import { useTranslation } from 'react-i18next';




 const SidebarData = [
    {
        title: "dashboard",
        path: "/dashboard",
        icon: <IoMdClipboard />,
    },
    {
        title: "users",
        path: "/users",
        icon: <IoMdPeople />,
        permission: "users_sidebar",
    },
    {
        title: "roles",
        path: "/roles",
        icon: <MdManageAccounts  />,
        permission: "roles_sidebar",
    },
    {
        title: "requests",
        path: "/requests",
        icon: <IoIosPaper />,
        permission: "requests_sidebar",
    },
    // {
    //     title: "documents",
    //     path: "/documents",
    //     icon: <IoIcons.IoMdDocument />,
    // },
    // {
    //     title: "Events",
    //     path: "/events",
    //     icon: <FaIcons.FaEnvelopeOpenText />,

    //     iconClosed: <RiIcons.RiArrowDownSFill />,
    //     iconOpened: <RiIcons.RiArrowUpSFill />,

    //     subNav: [
    //         {
    //             title: "Event 1",
    //             path: "/events/events1",
    //             icon: <IoIcons.IoIosPaper />,
    //         },
    //         {
    //             title: "Event 2",
    //             path: "/events/events2",
    //             icon: <IoIcons.IoIosPaper />,
    //         },
    //     ],
    // },
    {
        title: "codebooks",
        //path: "/codebooks",
        icon: <IoIcons.IoMdHelpCircle />,
        permission: "codebooks_sidebar",
        iconClosed: <RiIcons.RiArrowDownSFill />,
             iconOpened: <RiIcons.RiArrowUpSFill />,
    
            subNav: [
                {
                    title: "RequestTypes",
                    path: "/codebook/RequestTypes",
                    
                    //codebookType: 'RequestTypes',
                    //icon: <IoIcons.IoIosPaper />,
                },
                {
                    title: "Departments",
                    path: "/codebook/Departments",
                    //icon: <IoIcons.IoIosPaper />,
                },
                {
                    title: "RequestActionTypes",
                    path: "/codebook/RequestActionTypes",
                    //icon: <IoIcons.IoIosPaper />,
                },
                ,
                {
                    title: "Institutions",
                    path: "/codebook/Institutions",
                    //icon: <IoIcons.IoIosPaper />,
                },
            ],
    },
];

export default SidebarData;